// extracted by mini-css-extract-plugin
module.exports = {"lineWrapper":"ColoredCode_lineWrapper__V4UbO","lineReveal":"ColoredCode_lineReveal__T9_mS"};